import shopInpImage from "../assets/shop-inp.png"
import clubPresseGrenoble from "../assets/presse-grenoble.jpg"

export const projectsContent = [
    {
        name: 'Shop INP',
        type: 'WEB UI/UX Design',
        image: shopInpImage,
        text1: `During my time with the Net7 association, I collaborated with a team to develop a club shop website aimed at enhancing
                    accessibility to club merchandise for students. The website provides a seamless platform for students to browse and purchase
                    products from their favorite clubs, while also giving clubs an easy way to showcase their offerings.`,
        text2: `In this project, I worked as a front-end developer, leveraging Svelte and SvelteKit to build an interactive and engaging
                    user experience. This role allowed me to strengthen my CSS skills, with a focus on creating responsive designs optimized for mobile devices.`
    },
    {
        name: 'Report on discrimination and racism',
        type: 'Video report',
        image: clubPresseGrenoble,
        text1: `In 2018, I took on my first project that truly sparked my interest in audiovisual work. 
                I entered a competition where the goal was to create a report on discrimination and racism. `,
        text2: `With a small team of friends, we researched the topic and conducted interviews with students 
                and teachers at our school. Our efforts paid off—we had the honor of winning first prize, which
                 was presented to us at the Isère prefecture.`
    },
    {
        name: 'More to come...',
        type: '',
        image: '',
        text1: ``,
        text2: ``
    }
]